'use client';

import { useId, useState } from 'react';

import upperFirst from 'lodash/upperFirst';

import { useAuth } from '@shared/common/providers/AuthProvider';

import { ADS_CONSTANTS } from './AdsConstants';
import { useAppendScript, useUserAdSettings } from './hooks';

type StakingInlineMiddleBannerType =
  | 'stakingFarmsInlineMiddleBanner'
  | 'stakingMainInlineMiddleBanner'
  | 'storeAppInlineBottomBanner';

interface StakingInlineMiddleBanner {
  type: StakingInlineMiddleBannerType;
}

export const GlobalInlineMiddleBanner = ({ type }: StakingInlineMiddleBanner) => {
  const featureToggles = useUserAdSettings();
  const isBannerVisible = Boolean(featureToggles[`show${upperFirst(type)}`]);

  const { user } = useAuth();
  const [isLoaded, setIsLoaded] = useState(false);

  const id = useId();
  const userId = user?.id;

  useAppendScript({
    id,
    userId,
    onLoadImg: () => {
      setIsLoaded(true);
    },
  });

  if (!isBannerVisible) {
    return null;
  }

  return (
    <div id={id} className="relative h-24 w-full max-w-[736px] self-center">
      {!isLoaded && <div className="skeleton-block w-full h-full" />}
      <ins
        className={ADS_CONSTANTS.className}
        data-cp-user-id={userId}
        data-key={ADS_CONSTANTS[`${type}DataKey`]}
      />
    </div>
  );
};
